module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-596.dcaca66.woff2";